.headerContainer {
  container-type: inline-size;
}

@media all and (--reefer-media-tablet-min) {
  .header {
    flex-direction: row;
    gap: 4px;
  }
}

@container (max-width: 320px) {
  .header {
    flex-direction: column-reverse;
    gap: 8px;
  }
}
